import { Component, type OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

interface Message {
  id: number;
  text: string;
  sender: "user" | "bot";
  timestamp: Date;
}

@Component({
  selector: "app-landing-page-chat-bot",
  templateUrl: "./landing-page-chat-bot.component.html",
  styleUrls: ["./landing-page-chat-bot.component.css"],
})
export class LandingPageChatBotComponent {
  isOpen = false;
  isMinimized = false;
  inputValue = "";
  messages: Message[] = [
    {
      id: 1,
      text: "Welcome to KEMIS! 👋 I'm here to help you navigate our education management system. How can I assist you today?",
      sender: "bot",
      timestamp: new Date(),
    },
  ];

  ngOnInit(): void {
    // Auto-open after 3 seconds
    setTimeout(() => {
      this.isOpen = true;
    }, 3000);
  }

  sendMessage(): void {
    if (!this.inputValue.trim()) return;

    const userMessage: Message = {
      id: this.messages.length + 1,
      text: this.inputValue,
      sender: "user",
      timestamp: new Date(),
    };

    this.messages.push(userMessage);
    this.inputValue = "";

    // Simulate bot response
    setTimeout(() => {
      const responses = [
        "Thank you for your question! Our support team will provide detailed assistance shortly.",
        "I understand you need help with KEMIS. Let me connect you with the right resources.",
        "Great question! You can find more information in our Help Center or I can assist you directly.",
        "I'm here to help! For technical issues, please provide more details about what you're experiencing.",
      ];

      const botResponse: Message = {
        id: this.messages.length + 1,
        text: responses[Math.floor(Math.random() * responses.length)],
        sender: "bot",
        timestamp: new Date(),
      };
      this.messages.push(botResponse);
    }, 1000);
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      this.sendMessage();
    }
  }

  openChat(): void {
    this.isOpen = true;
  }

  closeChat(): void {
    this.isOpen = false;
  }

  toggleMinimize(): void {
    this.isMinimized = !this.isMinimized;
  }
}
